import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { CasinoComponent } from '../casino/casino.component';

@Component({
  selector: 'app-casino-detail',
  templateUrl: './casino-detail.component.html',
  styleUrls: ['./casino-detail.component.css']
})
export class CasinoDetailComponent extends CasinoComponent implements OnInit {
  public gameName: string = '';
  public iframeUrl: any;
  public gameId: any = '';
  public gameCode: any = '';

  @ViewChild("iframe") iframe!: ElementRef;

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    console.log('Back button pressed');
    // this.back();
  }

  ngOnInit(): void {

    let bodyclas = 'casino-detail-page';
    document.body.classList.add(bodyclas);

    this.gameId = this.actRoute.snapshot.paramMap.get('cgameId');
    this.gameCode = this.actRoute.snapshot.paramMap.get('cgameCode');
    this.id = Number(this.actRoute.snapshot.paramMap.get('id'));
    this.isMobile = this.width < this.mobileWidth ? true : false;

    if (this.events.casino1.includes(this.id)) {
      this.getData();
    } else if (this.events.iCasino.includes(this.id)) {
      this.IcasinoIframe();
    } else if (this.events.intCasino.includes(this.id)) {
      this.IntcasinoIframe();
    }


  }

  ngAfterContentChecked() {
    if (this.events.casino1.includes(this.id)) {
      this.casinoIframe();
    }
  }

  casinoIframe() {

    this.data?.event_types.forEach((element: any) => {
      if (element.id == this.gameId)
        this.gameName = element.name
    });

    if (this.data?.mobile_link) {
      let lId: any = this.data?.launch_ids ? this.data?.launch_ids[this.gameId] : this.gameId;

      this.iframeUrl = (this.gameId == '99999') ? this.data.web_link : `${this.data.web_link}/${lId}`
      if (this.isMobile) {
        this.iframeUrl = (this.gameId == '99999') ? this.data.mobile_link : `${this.data.mobile_link}/${lId}`
      } else {
        this.iframeUrl = (this.gameId == '99999') ? this.data.web_link : `${this.data.web_link}/${lId}`
      }
      //this.setIframe(this.iframeUrl);
      // this.iframeUrl = this._common.secureUrl(this.iframeUrl);

    }
    return `
      <iframe src=" + this.iframeUrl + " frameborder='0' scrolling='no' allow='autoplay'>
      </iframe>
    `;
  }

  IcasinoIframe() {
    this.isLoad = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.casinoITbl}/${this.gameId}`).subscribe(
      (res) => {
        if (res && res.status == true) {
          this.iframeUrl = res.data.iframe;
          this.setIframe(res.data.iframe);
          this.gameName = res.data.name;
        }
        this.isLoad = false;
      },
      (err) => {
        this.isLoad = false;
        console.log(err);
      });
  }

  IntcasinoIframe() {
    this.isLoad = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.casinoIntTbl}/${this.gameId}/${this.isMobile ? 1 : 0}`).subscribe(
      (res) => {
        if (res && res.status == true) {
          this.iframeUrl = res.data.iframe;
          this.setIframe(res.data.iframe);
          this.gameName = res.data.game_name;
        }
        this.isLoad = false;
      },
      (err) => {
        this.isLoad = false;
        console.log(err);
      });
  }

  setIframe(videoId: any) {
    // console.log(this.safeUrl.transform(videoId));
    // this.iframe.nativeElement.contentWindow.location.replace(this._common.secureUrl(videoId));
  }

  back() {
    this.router.navigate(['/casino', this.id]);
  }

  ngOnDestroy() {
    let bodyclas = 'casino-detail-page';
    document.body.classList.remove(bodyclas);
  }
}
